<template>
  <div class="page-wrapper">
    <header class="homapt-header">
      <div class="row header-row">
        <div class="col text-center my-auto">
          <h1 class="title">Making Real Estate</h1>
          <h1 class="title">Transparent</h1>
          <div class="row button-row">
            <div class="col-sm-6 col-md-3 offset-md-3">
              <button class="btn btn-secondary">Seller Milestone</button>
            </div>
            <div class="col-sm-6 col-md-3">
              <button class="btn btn-primary">Buyer Milestone</button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="pipe-wrapper">
      <!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 830 1200" style="enable-background:new 0 0 830 1200;" xml:space="preserve">
      <g id="Layer_1">
        <g id="lightpipe">
            <radialGradient id="SVGID_1_" cx="575.75" cy="450.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st0" d="M606.2,974v-46.6c-7.7-15-23.2-24.4-40-24.4h-26v50h11c5.5,0,10,4.5,10,10v11H606.2z"/>
            <radialGradient id="SVGID_2_" cx="351.95" cy="114.75" r="385.1793" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FCE0A4"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
            <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="97.2" y1="114.75" x2="606.7" y2="114.75" gradientTransform="matrix(1 0 0 1 0 488)">
            <stop  offset="0" style="stop-color:#FCE0A4"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </linearGradient>
          <path class="st1" d="M586.2,1084.5c-11,0-20-9-20-20v-118h-118c-19.3,0-35-15.7-35-35v-309h-161c-19.3,0-35-15.7-35-35v-135
            c0-19.3,15.7-35,35-35l0,0h298V161l-432.5,0.5l0,0c-11,0-20-9-20-20s9-20,20-20l437.5-0.5l0,0c19.3,0,35,15.7,35,35v246.5
            c0,19.3-15.7,35-35,35l0,0h-298v125h161c19.3,0,35,15.7,35,35v309h118c19.3,0,35,15.7,35,35v123
            C606.2,1075.5,597.3,1084.5,586.2,1084.5z"/>
            <radialGradient id="SVGID_4_" cx="560.3" cy="-337.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st2" d="M595.8,186h-50v-11c0-5.5-4.5-10-10-10h-11v-50h26c24.9,0,45,20.1,45,45V186z"/>
            <radialGradient id="SVGID_5_" cx="560.3" cy="-81.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st3" d="M595.8,371h-50v11c0,5.5-4.5,10-10,10h-11v50h26c24.9,0,45-20.1,45-45V371z"/>
            <radialGradient id="SVGID_6_" cx="423.3" cy="104.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st4" d="M458.8,628h-50v-11c0-5.5-4.5-10-10-10h-11v-50h26c24.9,0,45,20.1,45,45V628z"/>
            <radialGradient id="SVGID_7_" cx="11435.2002" cy="83.5" r="35.5" gradientTransform="matrix(-1 0 0 1 11682.5 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st5" d="M211.8,536h50v11c0,5.5,4.5,10,10,10h11v50h-26c-24.9,0-45-20.1-45-45L211.8,536L211.8,536z"/>
            <radialGradient id="SVGID_8_" cx="11759.2002" cy="427.5" r="35.5" gradientTransform="matrix(-1 0 0 1 12204.5 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st6" d="M409.8,880h50v11c0,5.5,4.5,10,10,10h11v50h-26c-24.9,0-45-20.1-45-45V880z"/>
            <radialGradient id="SVGID_9_" cx="11957.2002" cy="7417.5" r="35.5" gradientTransform="matrix(-1 0 0 -1 12204.5 7845)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#FDE4A6"/>
            <stop  offset="0.51" style="stop-color:#FCDD98"/>
            <stop  offset="1" style="stop-color:#FCD990"/>
          </radialGradient>
          <path class="st7" d="M211.8,463h50v-11c0-5.5,4.5-10,10-10h11v-50h-26c-24.9,0-45,20.1-45,45l0,0L211.8,463L211.8,463z"/>
        </g>
        <g id="darkpipe">
            <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="97.2" y1="134.75" x2="793.2" y2="134.75" gradientTransform="matrix(1 0 0 1 0 488)">
            <stop  offset="0" style="stop-color:#454D5C"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </linearGradient>
            <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="96.7" y1="134.75" x2="793.7" y2="134.75" gradientTransform="matrix(1 0 0 1 0 488)">
            <stop  offset="0" style="stop-color:#454D5C"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </linearGradient>
          <path class="st8" d="M626.2,1084.5c-11,0-20-9-20-20v-123c0-19.3,15.7-35,35-35h112v-141h-621c-19.3,0-35-15.7-35-35v-394
            c0-19.3,15.7-35,35-35l0,0h178.5V201.1l-192.9,0.4h-0.1c-11,0-20-8.9-20-20c0-11,8.9-20,20-20l0,0l198-0.5l0,0
            c19.3,0,35,15.7,35,35l0,0v110.5c0,19.3-15.7,35-35,35H137.2v384h616c22.1,0,40,17.9,40,40v141c0,22.1-17.9,40-40,40h-107v118
            C646.2,1075.5,637.3,1084.5,626.2,1084.5z"/>
            <radialGradient id="SVGID_12_" cx="319.7" cy="-176.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st9" d="M355.2,276h-50v11c0,5.5-4.5,10-10,10h-11v50h26c24.9,0,45-20.1,45-45V276z"/>
            <radialGradient id="SVGID_13_" cx="11791.2002" cy="247.5" r="35.5" gradientTransform="matrix(-1 0 0 1 11919.5 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st10" d="M92.8,700h50v11c0,5.5,4.5,10,10,10h11v50h-26c-24.9,0-45-20.1-45-45V700z"/>
            <radialGradient id="SVGID_14_" cx="320.3" cy="-297.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st11" d="M355.8,226h-50v-11c0-5.5-4.5-10-10-10h-11v-50h26c24.9,0,45,20.1,45,45V226z"/>
            <radialGradient id="SVGID_15_" cx="639.2" cy="450.5" r="34.2728" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st12" d="M606.2,927.4V974h45v-11c0-5.5,4.5-10,10-10h11v-50h-26C629.4,903,614,912.4,606.2,927.4z"/>
            <radialGradient id="SVGID_16_" cx="763.7" cy="267.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st13" d="M799.2,791h-50v-11c0-5.5-4.5-10-10-10h-11v-50h26c24.9,0,45,20.1,45,45V791z"/>
            <radialGradient id="SVGID_17_" cx="763.7" cy="427.5" r="35.5" gradientTransform="matrix(1 0 0 1 0 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st14" d="M799.2,880h-50v11c0,5.5-4.5,10-10,10h-11v50h26c24.9,0,45-20.1,45-45V880z"/>
            <radialGradient id="SVGID_18_" cx="11791.2002" cy="-156.5" r="35.5" gradientTransform="matrix(-1 0 0 1 11919.5 488)" gradientUnits="userSpaceOnUse">
            <stop  offset="0" style="stop-color:#474F5E"/>
            <stop  offset="1.000000e-02" style="stop-color:#474F5E"/>
            <stop  offset="0.55" style="stop-color:#3A424F"/>
            <stop  offset="1" style="stop-color:#353D4A"/>
          </radialGradient>
          <path class="st15" d="M92.8,367h50v-11c0-5.5,4.5-10,10-10h11v-50h-26c-24.9,0-45,20.1-45,45l0,0V367z"/>
        </g>
        <g id="grayclock6.1" class="clock" @mouseover="layer7 = true" @mouseleave="layer7 = false">
          <g id="Layer_2_8_">
            <g id="Layer_1-2_7_">
              <g id="_1_5_">
                  <linearGradient id="SVGID_19_" gradientUnits="userSpaceOnUse" x1="880.6566" y1="540.1731" x2="943.6614" y2="540.1731" gradientTransform="matrix(-8.081644e-02 -0.9967 0.9967 -8.081644e-02 236.1269 1881.9037)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st16" cx="700.8" cy="929.1" r="30"/>
                  <linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="912.2631" y1="514.2498" x2="912.053" y2="566.5496" gradientTransform="matrix(-8.081644e-02 -0.9967 0.9967 -8.081644e-02 236.1269 1881.9037)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st17" cx="700.8" cy="929.1" r="24.8"/>
                <circle class="st18" cx="700.8" cy="929.1" r="19.1"/>
                <path class="st19" d="M701.5,927c1.6,0.4,2.5,1.9,2.2,3.5c-0.4,1.6-1.9,2.5-3.5,2.2c-0.1,0-0.2,0-0.2-0.1
                  c-1.6-0.4-10.6-6.1-10.6-6.1S700,926.5,701.5,927z"/>
                <circle class="st20" cx="700.8" cy="929.1" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="grayclock5" class="clock" @mouseover="layer6 = true" @mouseleave="layer6 = false">
          <g id="Layer_2_27_">
            <g id="Layer_1-2_14_">
              <g id="_1_22_">
                  <linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="585.9709" y1="744.4732" x2="648.9828" y2="744.4732" gradientTransform="matrix(-0.9824 -0.1867 0.1867 -0.9824 1063.4161 1593.1534)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st21" cx="595.8" cy="746.5" r="30"/>
                  <linearGradient id="SVGID_22_" gradientUnits="userSpaceOnUse" x1="617.581" y1="718.5536" x2="617.371" y2="770.8536" gradientTransform="matrix(-0.9824 -0.1867 0.1867 -0.9824 1063.4161 1593.1534)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st22" cx="595.8" cy="746.5" r="24.8"/>
                <circle class="st18" cx="595.8" cy="746.5" r="19.1"/>
                <path class="st19" d="M593.9,745.2c0.8-1.4,2.5-1.9,3.9-1.2c1.4,0.8,1.9,2.5,1.2,3.9c0,0.1-0.1,0.1-0.1,0.2
                  c-0.8,1.4-8.7,8.6-8.7,8.6S593,746.6,593.9,745.2z"/>
                <circle class="st20" cx="595.8" cy="746.5" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="grayclock4" class="clock" @mouseover="layer5 = true" @mouseleave="layer5 = false">
          <g id="Layer_2_6_">
            <g id="Layer_1-2_5_">
              <g id="_1_3_">
                  <linearGradient id="SVGID_23_" gradientUnits="userSpaceOnUse" x1="136.0039" y1="712.8814" x2="199.0158" y2="712.8814" gradientTransform="matrix(-0.885 0.4656 -0.4656 -0.885 783.8638 1299.4075)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st23" cx="303.7" cy="746.5" r="30"/>
                  <linearGradient id="SVGID_24_" gradientUnits="userSpaceOnUse" x1="167.614" y1="686.951" x2="167.4039" y2="739.251" gradientTransform="matrix(-0.885 0.4656 -0.4656 -0.885 783.8638 1299.4075)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st24" cx="303.7" cy="746.5" r="24.8"/>
                <circle class="st18" cx="303.7" cy="746.5" r="19.1"/>
                <path class="st19" d="M301.4,746.7c-0.3-1.6,0.8-3.1,2.4-3.4c1.6-0.3,3.1,0.8,3.4,2.4c0,0.1,0,0.2,0,0.2
                  c0.2,1.6-1.4,12.2-1.4,12.2S301.6,748.3,301.4,746.7z"/>
                <circle class="st20" cx="303.7" cy="746.5" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="grayclock3" class="clock" @mouseover="layer4 = true" @mouseleave="layer4 = false">
          <g id="Layer_2_24_">
            <g id="Layer_1-2_12_">
              <g id="_1_20_">
                  <linearGradient id="SVGID_25_" gradientUnits="userSpaceOnUse" x1="-135.1934" y1="454.386" x2="-72.1898" y2="454.386" gradientTransform="matrix(-0.5608 0.828 -0.828 -0.5608 435.1813 912.1763)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st25" cx="117.1" cy="571.5" r="30"/>
                  <linearGradient id="SVGID_26_" gradientUnits="userSpaceOnUse" x1="-103.5876" y1="428.4781" x2="-103.7976" y2="480.7782" gradientTransform="matrix(-0.5608 0.828 -0.828 -0.5608 435.1813 912.1763)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st26" cx="117.1" cy="571.5" r="24.8"/>
                <circle class="st18" cx="117.1" cy="571.5" r="19.1"/>
                <path class="st19" d="M115.1,572.7c-1-1.3-0.8-3.1,0.5-4.1s3.1-0.8,4.1,0.5c0.1,0.1,0.1,0.1,0.1,0.2c0.9,1.3,4.5,11.4,4.5,11.4
                  S116,574,115.1,572.7z"/>
                <circle class="st20" cx="117.1" cy="571.5" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="grayclock2" class="clock" @mouseover="layer3 = true" @mouseleave="layer3 = false">
          <g id="Layer_2_4_">
            <g id="Layer_1-2_3_">
              <g id="_1_1_">
                  <linearGradient id="SVGID_27_" gradientUnits="userSpaceOnUse" x1="-129.7308" y1="41.0288" x2="-66.7212" y2="41.0288" gradientTransform="matrix(0.5143 0.8576 -0.8576 0.5143 202.6039 483.9375)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st27" cx="116.9" cy="420.8" r="30"/>
                  <linearGradient id="SVGID_28_" gradientUnits="userSpaceOnUse" x1="-98.1221" y1="15.1506" x2="-98.3321" y2="67.4506" gradientTransform="matrix(0.5143 0.8576 -0.8576 0.5143 202.6039 483.9375)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st28" cx="116.9" cy="420.8" r="24.8"/>
                <circle class="st18" cx="116.9" cy="420.8" r="19.1"/>
                <path class="st19" d="M117.2,423.1c-1.6,0.4-3.1-0.6-3.5-2.2s0.6-3.1,2.2-3.5c0.1,0,0.2,0,0.2,0c1.6-0.3,12.2,0.7,12.2,0.7
                  S118.8,422.8,117.2,423.1z"/>
                <circle class="st20" cx="116.9" cy="420.8" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="grayclock1_1_" class="clock" @mouseover="layer2 = true" @mouseleave="layer2 = false">
          <g id="Layer_2_21_">
            <g id="Layer_1-2_9_">
              <g id="_1_17_">
                  <linearGradient id="SVGID_29_" gradientUnits="userSpaceOnUse" x1="191" y1="-166.4" x2="254" y2="-166.4" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st29" cx="222.5" cy="321.6" r="30"/>
                  <linearGradient id="SVGID_30_" gradientUnits="userSpaceOnUse" x1="222.604" y1="-192.3064" x2="222.394" y2="-140.0065" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <circle class="st30" cx="222.5" cy="321.6" r="24.8"/>
                <circle class="st18" cx="222.5" cy="321.6" r="19.1"/>
                <path class="st19" d="M224.6,322.5c-0.5,1.5-2.1,2.4-3.7,1.9s-2.4-2.1-1.9-3.7c0-0.1,0.1-0.2,0.1-0.2
                  c0.6-1.5,6.9-10.1,6.9-10.1S225.1,321,224.6,322.5z"/>
                <circle class="st20" cx="222.5" cy="321.6" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="yellowclock6" class="clock" @mouseover="layer13 = true" @mouseleave="layer13 = false">
          <g id="Layer_2_14_">
            <g id="Yellow_5_">
              <g id="_1_11_">
                  <linearGradient id="SVGID_31_" gradientUnits="userSpaceOnUse" x1="711.3856" y1="657.8198" x2="774.3956" y2="657.8198" gradientTransform="matrix(0.1649 -0.9863 0.9863 0.1649 -259.0104 1554.4386)">
                  <stop  offset="0" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st31" cx="512.3" cy="930.2" r="30"/>
                  <linearGradient id="SVGID_32_" gradientUnits="userSpaceOnUse" x1="743.1006" y1="632.6356" x2="742.6907" y2="681.8057" gradientTransform="matrix(0.1649 -0.9863 0.9863 0.1649 -259.0104 1554.4386)">
                  <stop  offset="2.000000e-02" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st32" cx="512.3" cy="930.2" r="24.8"/>
                  <ellipse transform="matrix(0.9239 -0.3827 0.3827 0.9239 -316.9757 266.856)" class="st18" cx="512.3" cy="930.2" rx="19.1" ry="19.1"/>
                <path class="st19" d="M512.5,928.1c1.4,0.7,2,2.5,1.3,3.9s-2.5,2-3.9,1.3c-0.1,0-0.1-0.1-0.2-0.1c-1.4-0.8-8.8-8.5-8.8-8.5
                  C511.3,927.3,511.2,927.3,512.5,928.1z"/>
                <circle class="st20" cx="512.3" cy="930.2" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="yellowclock5" class="clock" @mouseover="layer12 = true" @mouseleave="layer12 = false">
          <g id="Layer_2_18_">
            <g id="Yellow_10_">
              <g id="_1_14_">
                  <linearGradient id="SVGID_33_" gradientUnits="userSpaceOnUse" x1="524.785" y1="776.2509" x2="587.7883" y2="776.2509" gradientTransform="matrix(-0.7963 -0.6049 0.6049 -0.7963 403.7169 1773.2263)">
                  <stop  offset="0" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st33" cx="430.3" cy="818.6" r="30"/>
                  <linearGradient id="SVGID_34_" gradientUnits="userSpaceOnUse" x1="556.4966" y1="751.0617" x2="556.0867" y2="800.2318" gradientTransform="matrix(-0.7963 -0.6049 0.6049 -0.7963 403.7169 1773.2263)">
                  <stop  offset="2.000000e-02" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st34" cx="430.3" cy="818.6" r="24.8"/>
                <circle class="st18" cx="430.3" cy="818.6" r="19.1"/>
                <path class="st19" d="M428.5,817.4c1.3-0.9,3.1-0.6,4.1,0.7c0.9,1.3,0.6,3.1-0.7,4.1c-0.1,0-0.1,0.1-0.2,0.1
                  c-1.4,0.9-11.6,3.9-11.6,3.9C427.3,818.2,427.2,818.2,428.5,817.4z"/>
                <circle class="st35" cx="430.3" cy="818.6" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="yellowclock4" class="clock" @mouseover="layer11 = true" @mouseleave="layer11 = false">
          <g id="Layer_2_12_">
            <g id="Yellow_3_">
              <g id="_1_9_">
                  <linearGradient id="SVGID_35_" gradientUnits="userSpaceOnUse" x1="86.5492" y1="472.5083" x2="149.5528" y2="472.5083" gradientTransform="matrix(-0.5922 0.8058 -0.8058 -0.5922 784.357 766.2939)">
                  <stop  offset="0" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st36" cx="333.7" cy="581.6" r="30"/>
                  <linearGradient id="SVGID_36_" gradientUnits="userSpaceOnUse" x1="118.2611" y1="447.3074" x2="117.8511" y2="496.4774" gradientTransform="matrix(-0.5922 0.8058 -0.8058 -0.5922 784.357 766.2939)">
                  <stop  offset="2.000000e-02" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st37" cx="333.7" cy="581.6" r="24.8"/>
                <circle class="st18" cx="333.7" cy="581.6" r="19.1"/>
                <path class="st19" d="M332.5,583.4c-0.9-1.3-0.7-3.1,0.6-4.1c1.3-0.9,3.1-0.7,4.1,0.6c0,0.1,0.1,0.1,0.1,0.2
                  c0.9,1.3,4.1,11.5,4.1,11.5C333.3,584.6,333.4,584.7,332.5,583.4z"/>
                <circle class="st20" cx="333.7" cy="581.6" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="yellowclock3" class="clock" @mouseover="layer10 = true" @mouseleave="layer10 = false">
          <g id="Layer_2_15_">
            <g id="Yellow_8_">
              <g id="_1_10_">
                  <linearGradient id="SVGID_37_" gradientUnits="userSpaceOnUse" x1="129.1512" y1="77.6851" x2="192.1696" y2="77.6851" gradientTransform="matrix(0.343 0.9393 -0.9393 0.343 415.6631 239.1457)">
                  <stop  offset="0" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st38" cx="397.8" cy="416.7" r="30"/>
                  <linearGradient id="SVGID_38_" gradientUnits="userSpaceOnUse" x1="160.8694" y1="52.6227" x2="160.4594" y2="101.7927" gradientTransform="matrix(0.343 0.9393 -0.9393 0.343 415.6631 239.1457)">
                  <stop  offset="2.000000e-02" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st39" cx="397.8" cy="416.7" r="24.8"/>
                <circle class="st18" cx="397.8" cy="416.7" r="19.1"/>
                <path class="st19" d="M398.5,418.7c-1.6,0.1-3-1.2-3-2.8s1.2-3,2.8-3c0.1,0,0.2,0,0.2,0c1.6,0,11.9,3,11.9,3
                  C400,418.7,400.1,418.7,398.5,418.7z"/>
                <circle class="st20" cx="397.8" cy="416.7" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="yellowclock2" class="clock" @mouseover="layer9 = true" @mouseleave="layer9 = false">
          <g id="Layer_2_10_">
            <g id="Yellow_1_">
              <g id="_1_7_">
                  <linearGradient id="SVGID_39_" gradientUnits="userSpaceOnUse" x1="401.1606" y1="-183.0376" x2="464.1635" y2="-183.0376" gradientTransform="matrix(0.8295 0.5586 -0.5586 0.8295 109.9154 180.1806)">
                  <stop  offset="0" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st40" cx="571" cy="270" r="30"/>
                  <linearGradient id="SVGID_40_" gradientUnits="userSpaceOnUse" x1="432.8074" y1="-208.177" x2="432.3973" y2="-159.007" gradientTransform="matrix(0.8295 0.5586 -0.5586 0.8295 109.9154 180.1806)">
                  <stop  offset="2.000000e-02" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st41" cx="571" cy="270" r="24.8"/>
                <circle class="st18" cx="571" cy="270" r="19.1"/>
                <path class="st19" d="M572.8,271.2c-1.3,1-3.1,0.8-4.1-0.5c-1-1.3-0.8-3.1,0.5-4.1c0.1-0.1,0.1-0.1,0.2-0.1
                  c1.3-0.9,11.4-4.5,11.4-4.5C574,270.3,574,270.3,572.8,271.2z"/>
                <circle class="st20" cx="571" cy="270" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="yellowclock1" class="clock" @mouseover="layer8 = true" @mouseleave="layer8 = false">
          <g id="Layer_2_9_">
            <g id="Yellow_4_">
              <g id="_1_4_">
                  <linearGradient id="SVGID_41_" gradientUnits="userSpaceOnUse" x1="398.8" y1="-345.7" x2="461.8" y2="-345.7" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st42" cx="430.3" cy="142.3" r="30"/>
                  <linearGradient id="SVGID_42_" gradientUnits="userSpaceOnUse" x1="430.5099" y1="-370.8797" x2="430.0999" y2="-321.7097" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="2.000000e-02" style="stop-color:#FFEDAA"/>
                  <stop  offset="1" style="stop-color:#FCD990"/>
                </linearGradient>
                <circle class="st43" cx="430.3" cy="142.3" r="24.8"/>
                <circle class="st18" cx="430.3" cy="142.3" r="19.1"/>
                <path class="st19" d="M432.4,142.2c-0.5,1.5-2.1,2.4-3.7,1.9s-2.4-2.1-1.9-3.7c0-0.1,0.1-0.2,0.1-0.2
                  c0.6-1.5,6.9-10.1,6.9-10.1C432.9,140.8,432.9,140.8,432.4,142.2z"/>
                <circle class="st20" cx="430.3" cy="142.3" r="32.5"/>
              </g>
            </g>
          </g>
        </g>
        <g id="blacktext">
          <text transform="matrix(1 0 0 1 150.75 280)" class="st44 st45">Sign Listing Contract</text>
          <text transform="matrix(1 0 0 1 6 410.3335)" class="st46"><tspan x="0" y="0" class="st44 st45">Complete</tspan><tspan x="0" y="16.8" class="st44 st45">Seller</tspan><tspan x="0" y="33.6" class="st44 st45">Disclosures</tspan></text>
          <text transform="matrix(1 0 0 1 242.75 707.333)" class="st44 st45">Show Your House</text>
          <text transform="matrix(1 0 0 1 548.083 707)" class="st44 st45">Review An Offer</text>
          <text transform="matrix(1 0 0 1 679.75 975.667)" class="st44 st45">Closing</text>
          <text transform="matrix(1 0 0 1 8 567)"><tspan x="0" y="0" class="st44 st45">List Your </tspan><tspan x="0" y="16.8" class="st44 st45">Property</tspan></text>
        </g>
        <g id="yellowtext">
          <text transform="matrix(1 0 0 1 389.5191 90)" class="st47 st44 st45">Understand</text>
          <text transform="matrix(1 0 0 1 389.5191 106.8)" class="st47 st44 st45">Your Finances</text>
          <text transform="matrix(1 0 0 1 606.15 272.792)" class="st47 st44 st45">Find A Lender</text>
          <text transform="matrix(1 0 0 1 357.7418 379.9998)" class="st47 st44 st45">Find A House</text>
          <text transform="matrix(1 0 0 1 292.72 546.7475)" class="st47 st44 st45">Make An Offer</text>
          <text transform="matrix(1 0 0 1 464.083 823.5502)" class="st47 st44 st45">Offer Accepted</text>
          <text transform="matrix(1 0 0 1 491.2453 975.333)" class="st47 st44 st45">Closing</text>
        </g>
        <g id="forsale">
          <g id="Layer_2_7_">
            <g id="Layer_1-2_8_">
              <g id="For_Sale_Sign_1_">
                <g id="Sold_1_">
                    <linearGradient id="SVGID_43_" gradientUnits="userSpaceOnUse" x1="107.95" y1="-395.33" x2="107.95" y2="-245.4" gradientTransform="matrix(1 0 0 1 0 488)">
                    <stop  offset="0" style="stop-color:#758096"/>
                    <stop  offset="1" style="stop-color:#353D4A"/>
                  </linearGradient>
                  <path class="st48" d="M60.2,98.5h95.5c11,0,20,9,20,20V214c0,11-9,20-20,20H60.2c-11,0-20-9-20-20v-95.5
                    C40.2,107.5,49.1,98.5,60.2,98.5z"/>
                    <linearGradient id="SVGID_44_" gradientUnits="userSpaceOnUse" x1="107.9363" y1="-398.97" x2="107.9363" y2="-244.94" gradientTransform="matrix(1 0 0 1 0 488)">
                    <stop  offset="0" style="stop-color:#758096"/>
                    <stop  offset="1" style="stop-color:#7683AC"/>
                  </linearGradient>
                  <path class="st49" d="M146.9,202.3h-4.5c-0.7,0-1.3-0.6-1.3-1.3l0,0v-28.8h4.2c1.2,0,2.4-0.7,2.8-1.8c0.5-1.1,0.3-2.4-0.5-3.4
                    l-8.6-9.8l-23.6-26.8l-6.3-7.1c-0.6-0.6-1.6-0.7-2.3-0.1c0,0,0,0-0.1,0.1l-14.1,16V138c0-1.7-1.4-3.1-3.1-3.1H84
                    c-1.7,0-3.1,1.4-3.1,3.1v14.6L68.5,167c-0.8,0.9-1,2.2-0.5,3.4c0.5,1.1,1.6,1.9,2.8,1.8h4.4V201c0,0.7-0.6,1.3-1.3,1.3l0,0
                    h-5.1c-0.7,0-1.3,0.6-1.3,1.3c0,1.3,0,3.5,0,4.8c0,0.7,0.6,1.3,1.3,1.4c0,0,0,0,0.1,0H147c0.7,0,1.3-0.6,1.3-1.3v-4.8
                    C148.2,202.9,147.7,202.3,146.9,202.3L146.9,202.3z"/>
                </g>
                  <linearGradient id="SVGID_45_" gradientUnits="userSpaceOnUse" x1="112.0442" y1="-256.9976" x2="57.6942" y2="-354.8176" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st50" d="M59.4,155.3l6.4-3.3l4.4,8.6l5.9-3l1.9,3.8l-5.9,3l3.5,6.9l-6.4,3.3L59.4,155.3z M68.8,155.4l-2-3.9
                  l9.8-5l3.2,6.5l-6.4,3.3l-1.3-2.5L68.8,155.4z"/>
                  <linearGradient id="SVGID_46_" gradientUnits="userSpaceOnUse" x1="129.4723" y1="-266.6842" x2="75.1323" y2="-364.5043" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st51" d="M91.7,158.7l1.7-0.8l1.8,3.6l-4.3,2.2l-5.8-1.9l-3.9-7.8l1.9-5.8l4.3-2.2l2,3.8l-1.7,0.9L91.7,158.7z
                   M102.4,153l-1.9,5.8l-4.3,2.2l-1.8-3.6l1.6-0.8l-4-8l-1.6,0.8l-2-3.9l4.3-2.2l5.8,1.9L102.4,153z"/>
                  <linearGradient id="SVGID_47_" gradientUnits="userSpaceOnUse" x1="148.9355" y1="-277.4927" x2="94.5855" y2="-375.3127" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st52" d="M107.2,155.4l-7.8-15.5l6.4-3.2l7.8,15.5L107.2,155.4z M111.6,138.6l-2.7,1.4l-0.8-1.7l1.1-3.3l3.9-2l5,2
                  l2,4l-6.4,3.3L111.6,138.6z"/>
                  <linearGradient id="SVGID_48_" gradientUnits="userSpaceOnUse" x1="101.6013" y1="-246.1034" x2="70.6713" y2="-312.1534" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st53" d="M87.3,202.9l-3.7-7.2l-8.4,4.2l-5.8-1.9l-2.2-4.4l1.9-5.8l2.2-1.1l3.5,6.9l8.9-4.5l5.7,2l2.4,4.7
                  l-1.9,5.8L87.3,202.9z M72.2,203.3l6.4-3.3l1.2,2.3l4.8-2.4l1.8,3.5l-8,4l-5.2-2.2L72.2,203.3z M74.2,189.7l-1.8-3.5l7.7-3.9
                  l5,1.7l1,2l-5.9,3l-1-1.9L74.2,189.7z"/>
                  <linearGradient id="SVGID_49_" gradientUnits="userSpaceOnUse" x1="123.9589" y1="-256.5751" x2="93.0189" y2="-322.6252" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st54" d="M101.5,195.7l-6.2,3.1l-2.4-21.9l6.8,6.2L101.5,195.7z M108.5,189.5l-6.3,3.2l-0.6-4.5l3.5-1.8l-12-10.8
                  l6.3-3.2l17.5,15.4l-6.5,3.3L108.5,189.5z"/>
                  <linearGradient id="SVGID_50_" gradientUnits="userSpaceOnUse" x1="144.7718" y1="-266.3283" x2="113.8418" y2="-332.3783" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st55" d="M118.7,187l-9.8-19.3l6.4-3.2l9.8,19.3L118.7,187z M126.2,183.2l-2-3.9l3.2-1.6l-1.2-2.4l5.8-3l3.2,6.3
                  L126.2,183.2z"/>
                  <linearGradient id="SVGID_51_" gradientUnits="userSpaceOnUse" x1="164.0302" y1="-275.3424" x2="133.0902" y2="-341.3924" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <path class="st56" d="M139.6,166.5l4,7.9l-6.4,3.2l-9.8-19.3l6.4-3.3l3.9,7.7l6.2-3.1l1.9,3.7L139.6,166.5z M136.8,158.3
                  l-1.9-3.7l10.1-5.1l2.8,5.6l-6.1,3.1l-0.9-1.8L136.8,158.3z M144.7,173.9l-2-3.9l3.6-1.8l-1-1.9l6.5-3.2l2.9,5.8L144.7,173.9z"
                  />
              </g>
            </g>
          </g>
        </g>
        <g id="sold">
          <title>Asset 3</title>
          <g id="Layer_2_2_">
            <g id="Layer_1-2_1_">
              <g id="Sold_Sign">
                <path class="st57" d="M583,1009.8h45.7c18.9,0,34.2,15.3,34.2,34.1v45.7c0,18.9-15.3,34.2-34.2,34.2H583
                  c-18.9,0-34.2-15.3-34.2-34.2V1044C548.9,1025.1,564.1,1009.8,583,1009.8z"/>
                  <linearGradient id="SVGID_52_" gradientUnits="userSpaceOnUse" x1="606.25" y1="507.2428" x2="606.25" y2="657.1728" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#353D4A"/>
                </linearGradient>
                <path class="st58" d="M558.3,1001.1h95.9c11,0,20,9,20,20v95.5c0,11-9,20-20,20h-95.9c-11,0-20-9-20-20v-95.5
                  C538.3,1010,547.3,1001.1,558.3,1001.1z"/>
                  <linearGradient id="SVGID_53_" gradientUnits="userSpaceOnUse" x1="606.2863" y1="503.2728" x2="606.2863" y2="653.9628" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#758096"/>
                  <stop  offset="1" style="stop-color:#7683AC"/>
                </linearGradient>
                <path class="st59" d="M644.4,1102.1H640c-0.7,0-1.3-0.6-1.3-1.3l0,0v-28.2h4.2c1.2,0,2.3-0.7,2.8-1.8s0.3-2.4-0.5-3.3l-8.4-9.6
                  l-23-26.3l-6.1-7c-0.6-0.6-1.6-0.7-2.2-0.1c0,0,0,0-0.1,0.1l-13.8,15.7v-1.2c0-1.7-1.4-3.1-3.1-3.1H583c-1.7,0-3.1,1.4-3.1,3.1
                  v14.3l-12.3,14.1c-0.8,0.9-1,2.2-0.5,3.3s1.6,1.8,2.8,1.8h4.3v28.2c0,0.7-0.6,1.3-1.3,1.3l0,0h-5c-0.7,0-1.3,0.6-1.3,1.3
                  c0,1.3,0,3.4,0,4.7c0,0.7,0.5,1.3,1.3,1.3l0,0h76.4c0.7,0,1.3-0.6,1.3-1.3v-4.7C645.7,1102.8,645.1,1102.1,644.4,1102.1z"/>
                  <linearGradient id="SVGID_54_" gradientUnits="userSpaceOnUse" x1="585.3032" y1="631.848" x2="565.963" y2="569.638" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st60" points="572.2,1078.8 573.1,1080.9 579.7,1078 578.7,1075.7 573.3,1073.6 564.7,1077.4 566.4,1081.3
                            "/>
                  <linearGradient id="SVGID_55_" gradientUnits="userSpaceOnUse" x1="582.5178" y1="632.721" x2="563.1777" y2="570.511" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st61" points="576.9,1081.2 567,1085.6 563.6,1078 561.2,1079 558.8,1085.2 560.9,1090.1 567.1,1092.5
                  576.4,1088.3 580,1096.4 582.9,1095.1 585.3,1088.9 582.9,1083.7           "/>
                  <linearGradient id="SVGID_56_" gradientUnits="userSpaceOnUse" x1="579.0759" y1="633.7841" x2="559.736" y2="571.5741" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st62" points="571.8,1095.4 570.7,1092.8 563.5,1096 564.5,1098.2 570,1100.8 578.9,1096.9 577.2,1093           "/>
                  <linearGradient id="SVGID_57_" gradientUnits="userSpaceOnUse" x1="601.7078" y1="626.7565" x2="582.3779" y2="564.5466" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st63" points="595.4,1084.3 589.7,1071.6 592.4,1070.4 590.5,1066 585,1068.5 582.5,1074.7 588.2,1087.6
                  594.5,1090 600,1087.5 598.1,1083.1           "/>
                  <linearGradient id="SVGID_58_" gradientUnits="userSpaceOnUse" x1="612.6563" y1="623.3445" x2="593.3263" y2="561.1346" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st64" points="597.2,1063 591.6,1065.5 593.5,1069.9 596.3,1068.7 602,1081.4 599.2,1082.6 601.2,1087
                  606.7,1084.5 609.2,1078.3 603.4,1065.4           "/>
                  <linearGradient id="SVGID_59_" gradientUnits="userSpaceOnUse" x1="625.17" y1="619.4659" x2="605.8298" y2="557.2559" gradientTransform="matrix(1 0 0 1 -1.301662e-03 487.9937)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st65" points="604.8,1059.6 612,1056.5 621.5,1078 614.4,1081.1           "/>
                  <linearGradient id="SVGID_60_" gradientUnits="userSpaceOnUse" x1="636.3519" y1="615.986" x2="617.0119" y2="553.776" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st66" points="623.1,1068.9 624.3,1071.6 620.8,1073.2 622.7,1077.5 632.7,1073 629.6,1066           "/>
                  <linearGradient id="SVGID_61_" gradientUnits="userSpaceOnUse" x1="646.483" y1="612.8318" x2="627.153" y2="550.6219" gradientTransform="matrix(1 0 0 1 -1.055968e-03 488.0045)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st67" points="625.3,1050.5 632.5,1047.4 642.1,1068.9 634.9,1072           "/>
                  <linearGradient id="SVGID_62_" gradientUnits="userSpaceOnUse" x1="657.606" y1="609.3809" x2="638.2661" y2="547.1709" gradientTransform="matrix(1 0 0 1 0 488)">
                  <stop  offset="0" style="stop-color:#F5B387"/>
                  <stop  offset="1" style="stop-color:#FAEB96"/>
                </linearGradient>
                <polygon class="st68" points="648,1045.6 641.8,1043.2 633.6,1046.8 635.5,1051.1 640.9,1048.8 646.6,1061.7 641.3,1064.1
                  643.2,1068.4 651.4,1064.7 653.8,1058.5           "/>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_2" v-bind:class="{ 'textbox-visible': layer2, textbox: !layer2 }">
        <rect x="115.4" y="185.2" class="st69" width="214.3" height="97.6"/>
        <text transform="matrix(1 0 0 1 121.3633 219.5449)"><tspan x="0" y="0" class="st44 st70">Meet with several realtors before signing a</tspan><tspan x="0" y="12" class="st44 st70">contract. Once you have decided, sign a</tspan><tspan x="0" y="24" class="st44 st70">contract and determine listing price.</tspan></text>
        <text transform="matrix(1 0 0 1 120.3633 262.5449)"><tspan x="0" y="0" class="st44 st70">Contract determines commissions, length</tspan><tspan x="0" y="12" class="st44 st70">of contract, and arbitration preference.</tspan></text>
        <text transform="matrix(1 0 0 1 121.5 202.3965)" class="st44 st71">Sign Listing Contract</text>
      </g>
      <g id="Layer_6" v-bind:class="{ 'textbox-visible': layer6, textbox: !layer6 }">
        <rect x="481.3" y="632.3" class="st69" width="228.9" height="79.6"/>
        <text transform="matrix(1 0 0 1 488.341 645.3313)" class="st44 st71">Review An Offer</text>
        <text transform="matrix(1 0 0 1 487.341 661.3313)"><tspan x="0" y="0" class="st44 st70">Potential buyers will submit an offer to you.</tspan><tspan x="0" y="12" class="st44 st70">You can accept, counter or decline the offer.</tspan></text>
        <text transform="matrix(1 0 0 1 488.341 692.3313)"><tspan x="0" y="0" class="st44 st70">Your HomApt Agent will provide guidance </tspan><tspan x="0" y="12" class="st44 st70">as you need and facilitate next steps.</tspan></text>
      </g>
      <g id="Layer_7" v-bind:class="{ 'textbox-visible': layer7, textbox: !layer7 }">
        <rect x="573.3" y="808.1" class="st69" width="255" height="81"/>
        <text transform="matrix(1 0 0 1 582.3 822.1)" class="st44 st71">Get Ready to Close</text>
        <text transform="matrix(1 0 0 1 582.3 836.1)"><tspan x="0" y="0" class="st44 st70">Buyer usually sets closing date as it can </tspan><tspan x="0" y="12" class="st44 st70">be dependent on financing or contingencies.</tspan></text>
        <text transform="matrix(1 0 0 1 582.3 865.1)"><tspan x="0" y="0" class="st44 st70">Get the movers, attend the closing to get</tspan><tspan x="0" y="12" class="st44 st70">your proceeds, and enjoy your next adventure!</tspan></text>
      </g>
      <g id="Layer_8" v-bind:class="{ 'textbox-visible': layer8, textbox: !layer8 }">
        <rect x="309.9" y="15.8" class="st69" width="240.8" height="91"/>
        <text transform="matrix(1 0 0 1 318.8937 31.8)" class="st44 st71">Understand Your Finances</text>
        <text transform="matrix(1 0 0 1 320.8937 44.8)"><tspan x="0" y="0" class="st44 st70">Know how much you can spend before getting</tspan><tspan x="0" y="12" class="st44 st70">too far in the process. Use a Mortgage Calculator</tspan><tspan x="0" y="24" class="st44 st70">to determine how much you can afford.</tspan></text>
        <text transform="matrix(1 0 0 1 319.8937 83.8)"><tspan x="0" y="0" class="st44 st70">https://usmortgagecalculator.org</tspan></text>
      </g>
      <g id="Layer_9" v-bind:class="{ 'textbox-visible': layer9, textbox: !layer9 }">
        <rect x="464.5" y="121.4" class="st69" width="213" height="111"/>
        <text transform="matrix(1 0 0 1 472.5 139.4)" class="st44 st71">Find A Lender</text>
        <text transform="matrix(1 0 0 1 472.5 153.4)"><tspan x="0" y="0" class="st44 st70">If you need a lender, find a mortgage broker.</tspan><tspan x="0" y="12" class="st44 st70">Mortgage Brokers can find the loan that's</tspan><tspan x="0" y="24" class="st44 st70">right for you.</tspan></text>
        <text transform="matrix(1 0 0 1 472.5 193.4)"><tspan x="0" y="0" class="st44 st70">Get a pre-approval letter to make your offer</tspan><tspan x="0" y="12" class="st44 st70">more competitive. HomApt Marketplace</tspan><tspan x="0" y="24" class="st44 st70">is a great place to start your search.</tspan></text>
      </g>
      <g id="Layer_10" v-bind:class="{ 'textbox-visible': layer10, textbox: !layer10 }">
        <rect x="291.3" y="259.4" class="st69" width="213" height="121.1"/>
        <text transform="matrix(1 0 0 1 298.3 277.5)" class="st44 st71">Find A house</text>
        <text transform="matrix(1 0 0 1 299.3 293.5)"><tspan x="0" y="0" class="st44 st70">Use the HomeSpotter App to easily find</tspan><tspan x="0" y="12" class="st44 st70">homes and schedule showings with your</tspan><tspan x="0" y="24" class="st44 st70">realtor. Keep in mind your current and</tspan><tspan x="0" y="36" class="st44 st70">future housing needs.</tspan></text>
        <text transform="matrix(1 0 0 1 299.3 347.5)"><tspan x="0" y="0" class="st44 st70">HomApt realtors use HomeSpotter to</tspan><tspan x="0" y="12" class="st44 st70">understand your preferences, and actively</tspan><tspan x="0" y="24" class="st44 st70">look for other houses you may like.</tspan></text>
      </g>
      <g id="Layer_11" v-bind:class="{ 'textbox-visible': layer11, textbox: !layer11 }">
        <rect x="229.9" y="415.1" class="st69" width="212.6" height="130.7"/>
        <text transform="matrix(1 0 0 1 235.8856 430.8)" class="st44 st71">Make An Offer</text>
        <text transform="matrix(1 0 0 1 235.8856 445.8)"><tspan x="0" y="0" class="st44 st70">Once you find your house, your</tspan><tspan x="0" y="12" class="st44 st70">HomApt realtor will help you make an offer.</tspan><tspan x="0" y="24" class="st44 st70">Buyer should submit earnest money (1.5%</tspan></text>
        <text transform="matrix(1 0 0 1 235.8856 483.6)"><tspan x="0" y="0" class="st44 st70">of offer price) and list any contingencies</tspan><tspan x="0" y="12" class="st44 st70">(home inspection or selling your current</tspan><tspan x="0" y="24" class="st44 st70">home) in the Purchase Agreement/offer.</tspan></text>
        <text transform="matrix(1 0 0 1 235.8856 521.8)"><tspan x="0" y="0" class="st44 st70">HomApt makes this part easy!</tspan></text>
      </g>
      <g id="Layer_12" v-bind:class="{ 'textbox-visible': layer12, textbox: !layer12 }">
        <rect x="316.5" y="712" class="st69" width="233.3" height="74"/>
        <text transform="matrix(1 0 0 1 323.4786 725.975)" class="st44 st71">Offer Accepted</text>
        <text transform="matrix(1 0 0 1 323.4786 737.975)"><tspan x="0" y="0" class="st44 st70">After you submit an offer, the buyer can</tspan><tspan x="0" y="12" class="st44 st70">accept decline or counter.</tspan></text>
        <text transform="matrix(1 0 0 1 323.4786 764.975)"><tspan x="0" y="0" class="st44 st70">Once your offer is accepted, you are ready</tspan><tspan x="0" y="12" class="st44 st70">to close! Contact your lender for next steps.</tspan></text>
      </g>
      <g id="Layer_13" v-bind:class="{ 'textbox-visible': layer13, textbox: !layer13 }">
        <rect x="389.8" y="807.6" class="st69" width="245" height="82"/>
        <text transform="matrix(1 0 0 1 399.8 826.6)" class="st44 st71">Get Ready to Close</text>
        <text transform="matrix(1 0 0 1 399.8 840.6)"><tspan x="0" y="0" class="st44 st70">Buyer usually sets closing date as it can</tspan><tspan x="0" y="12" class="st44 st70">be dependent on financing.</tspan></text>
        <text transform="matrix(1 0 0 1 399.8 866.4)"><tspan x="0" y="0" class="st44 st70">At closing, bring your down payment/closing</tspan><tspan x="0" y="12" class="st44 st70">costs and move in to your new house!</tspan></text>
      </g>
      <g id="Layer_3" v-bind:class="{ 'textbox-visible': layer3, textbox: !layer3 }">
        <rect x="11.4" y="282" class="st69" width="211" height="99"/>
        <text transform="matrix(1 0 0 1 21.4 299)" class="st44 st71">Complete Seller Disclosures</text>
        <text transform="matrix(1 0 0 1 21.4 319)"><tspan x="0" y="0" class="st44 st70">Tell us about your home! Legally, buyers</tspan><tspan x="0" y="12" class="st44 st70">need to know all about your house and</tspan><tspan x="0" y="24" class="st44 st70">property.</tspan></text>
        <text transform="matrix(1 0 0 1 20.4 358)"><tspan x="0" y="0" class="st44 st70">Use the HomApt Questionnaire to make</tspan><tspan x="0" y="12" class="st44 st70">this process quick and easy.</tspan></text>
      </g>
      <g id="Layer_4" v-bind:class="{ 'textbox-visible': layer4, textbox: !layer4 }">
        <rect x="12.9" y="418.7" class="st69" width="213" height="113"/>
        <text transform="matrix(1 0 0 1 19.8838 434.7054)" class="st44 st71">List Property With MLS</text>
        <text transform="matrix(1 0 0 1 19.8838 449.7054)"><tspan x="0" y="0" class="st44 st70">Let everyone know why you love your</tspan><tspan x="0" y="12" class="st44 st70">home! Give the MLS permission to share</tspan><tspan x="0" y="24" class="st44 st70">your home details with others who are </tspan><tspan x="0" y="36" class="st44 st70">looking to buy.</tspan></text>
        <text transform="matrix(1 0 0 1 18.8838 498.7054)"><tspan x="0" y="0" class="st44 st70">HomApt will get pro photos taken, install a</tspan><tspan x="0" y="12" class="st44 st70">yard sign, and host an Open House.</tspan></text>
      </g>
      <g id="Layer_5" v-bind:class="{ 'textbox-visible': layer5, textbox: !layer5 }">
        <rect x="192.1" y="591.6" class="st69" width="224.4" height="120.3"/>
        <text transform="matrix(1 0 0 1 198.075 605.6)" class="st44 st71">Show Your House</text>
        <text transform="matrix(1 0 0 1 197.075 619.6)"><tspan x="0" y="0" class="st44 st70">Having an Open House allows for multiple</tspan><tspan x="0" y="12" class="st44 st70">potential buyers to view your property at</tspan><tspan x="0" y="24" class="st44 st70">one time. Put your best foot forward</tspan></text>
        <text transform="matrix(1 0 0 1 197.075 654.6)"><tspan x="0" y="0" class="st44 st70"> by making sure your home is clean and inviting.</tspan><tspan x="0" y="12" class="st44 st70"></tspan></text>
        <text transform="matrix(1 0 0 1 196.075 689.6)"><tspan x="0" y="0" class="st44 st70">HomApt makes scheduling Open Houses</tspan><tspan x="0" y="12" class="st44 st70">and Showings easy!</tspan></text>
      </g>
      </svg>
    </div>
    <div class="jumbotron">
     <div class="row">
       <div class="col text-center">
         <h3>Get a HomApt Agent Today!</h3>
         <router-link to="/contact">
           <button class="btn btn-secondary">Contact Us</button>
         </router-link>
       </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Roadmap',
    meta: [
      { vmid: 'description', content: 'fill in' }
    ]
  },
  data () {
    return {
      layer2: false,
      layer3: false,
      layer4: false,
      layer5: false,
      layer6: false,
      layer7: false,
      layer8: false,
      layer9: false,
      layer10: false,
      layer11: false,
      layer12: false,
      layer13: false,
      email: null,
      success: false,
      unavailable: false,
      emailInvalid: false
    }
  }
}
</script>

<style scoped>
.st0{fill:url(#SVGID_1_);}
.st1{fill:url(#SVGID_2_);stroke:url(#SVGID_3_);stroke-miterlimit:10;}
.st2{fill:url(#SVGID_4_);}
.st3{fill:url(#SVGID_5_);}
.st4{fill:url(#SVGID_6_);}
.st5{fill:url(#SVGID_7_);}
.st6{fill:url(#SVGID_8_);}
.st7{fill:url(#SVGID_9_);}
.st8{fill:url(#SVGID_10_);stroke:url(#SVGID_11_);stroke-miterlimit:10;}
.st9{fill:url(#SVGID_12_);}
.st10{fill:url(#SVGID_13_);}
.st11{fill:url(#SVGID_14_);}
.st12{fill:url(#SVGID_15_);}
.st13{fill:url(#SVGID_16_);}
.st14{fill:url(#SVGID_17_);}
.st15{fill:url(#SVGID_18_);}
.st16{fill:none;stroke:url(#SVGID_19_);stroke-width:3;stroke-miterlimit:10;}
.st17{fill:url(#SVGID_20_);}
.st18{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:5;}
.st19{fill:#FFFFFF;}
.st20{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}
.st21{fill:none;stroke:url(#SVGID_21_);stroke-width:3;stroke-miterlimit:10;}
.st22{fill:url(#SVGID_22_);}
.st23{fill:none;stroke:url(#SVGID_23_);stroke-width:3;stroke-miterlimit:10;}
.st24{fill:url(#SVGID_24_);}
.st25{fill:none;stroke:url(#SVGID_25_);stroke-width:3;stroke-miterlimit:10;}
.st26{fill:url(#SVGID_26_);}
.st27{fill:none;stroke:url(#SVGID_27_);stroke-width:3;stroke-miterlimit:10;}
.st28{fill:url(#SVGID_28_);}
.st29{fill:none;stroke:url(#SVGID_29_);stroke-width:3;stroke-miterlimit:10;}
.st30{fill:url(#SVGID_30_);}
.st31{fill:#FFFFFF;stroke:url(#SVGID_31_);stroke-width:3;stroke-miterlimit:10;}
.st32{fill:url(#SVGID_32_);}
.st33{fill:#FFFFFF;stroke:url(#SVGID_33_);stroke-width:3;stroke-miterlimit:10;}
.st34{fill:url(#SVGID_34_);}
.st35{fill:none;}
.st36{fill:#FFFFFF;stroke:url(#SVGID_35_);stroke-width:3;stroke-miterlimit:10;}
.st37{fill:url(#SVGID_36_);}
.st38{fill:#FFFFFF;stroke:url(#SVGID_37_);stroke-width:3;stroke-miterlimit:10;}
.st39{fill:url(#SVGID_38_);}
.st40{fill:#FFFFFF;stroke:url(#SVGID_39_);stroke-width:3;stroke-miterlimit:10;}
.st41{fill:url(#SVGID_40_);}
.st42{fill:#FFFFFF;stroke:url(#SVGID_41_);stroke-width:3;stroke-miterlimit:10;}
.st43{fill:url(#SVGID_42_);}
.st44{font-family:inherit}
.st45{font-size:14px;}
.st46{enable-background:new    ;}
.st47{fill:#F7CC41;}
.st48{fill:url(#SVGID_43_);stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}
.st49{fill:url(#SVGID_44_);}
.st50{fill:url(#SVGID_45_);}
.st51{fill:url(#SVGID_46_);}
.st52{fill:url(#SVGID_47_);}
.st53{fill:url(#SVGID_48_);}
.st54{fill:url(#SVGID_49_);}
.st55{fill:url(#SVGID_50_);}
.st56{fill:url(#SVGID_51_);}
.st57{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}
.st58{fill:url(#SVGID_52_);stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}
.st59{fill:url(#SVGID_53_);}
.st60{fill:url(#SVGID_54_);}
.st61{fill:url(#SVGID_55_);}
.st62{fill:url(#SVGID_56_);}
.st63{fill:url(#SVGID_57_);}
.st64{fill:url(#SVGID_58_);}
.st65{fill:url(#SVGID_59_);}
.st66{fill:url(#SVGID_60_);}
.st67{fill:url(#SVGID_61_);}
.st68{fill:url(#SVGID_62_);}
.st69{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}
.st70{font-size:10px;}
.st71{font-size:12px;}

.title {
  color: white !important;
}

.homapt-header {
  height: 50vh !important;
}

.header-row {
  height: 100%;
}

.button-row {
  margin-top: 4rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.btn {
  margin-bottom: 1rem;
}

.btn-secondary-nomargin {
  margin-bottom: 0 !important;
}

.homapt-header {
  background-image: url("../../assets/shapebackground.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.pipe-wrapper {
  position: relative;
  margin-right: 3rem;
  margin-left: 3rem;
}

.clock {
  -webkit-transform: scale(1);
  -webkit-transform-origin: 50% 50%;
  -webkit-transition:.3s;
  transform: scale(1);
  transform-origin: 50% 50%;
  transition:.3s;
  transform-box: fill-box;
}

.clock:hover {
  -webkit-transform: scale(1.1);
  -webkit-transform-origin: 50% 50%;
  -webkit-transition:.3s;
  transform: scale(1.1);
  transform-origin: 50% 50%;
  transition:.3s;
  cursor: pointer;
}

.textbox {
  visibility: hidden;
}

textbox-visible {
  visibility: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/roadmap/TheRoadmap.vue